const RADIUS = 42;
const PROGRESS_PATH_LENGTH = 100;

export default function CircularProgress({
  value,
  max = 100,
  displayValue,
  label,
  ariaLabel,
  tone = "brand",
  size = "md",
  className = "",
}) {
  const numericValue = Number(value);
  const numericMax = Number(max);
  const hasValue = value !== null
    && value !== undefined
    && value !== ""
    && Number.isFinite(numericValue)
    && Number.isFinite(numericMax)
    && numericMax > 0;
  const progress = hasValue ? Math.min(Math.max(numericValue / numericMax, 0), 1) : 0;
  const dashOffset = PROGRESS_PATH_LENGTH * (1 - progress);
  const visibleValue = displayValue ?? (hasValue ? `${Math.round(numericValue)}%` : "-");
  const accessibleLabel = ariaLabel || `${label || "진행률"} ${visibleValue}`;

  return (
    <div
      className={`ds-circular-progress ds-circular-progress--${size} ds-circular-progress--${tone}${className ? ` ${className}` : ""}`}
      role="img"
      aria-label={accessibleLabel}
    >
      <svg viewBox="0 0 100 100" aria-hidden="true">
        <circle cx="50" cy="50" r={RADIUS} pathLength={PROGRESS_PATH_LENGTH} className="ds-circular-progress__track" />
        <circle
          cx="50"
          cy="50"
          r={RADIUS}
          pathLength={PROGRESS_PATH_LENGTH}
          className="ds-circular-progress__indicator"
          strokeDasharray={`${PROGRESS_PATH_LENGTH} ${PROGRESS_PATH_LENGTH}`}
          strokeDashoffset={dashOffset}
        />
      </svg>
      <span className="ds-circular-progress__content">
        <strong>{visibleValue}</strong>
        {label ? <small>{label}</small> : null}
      </span>
    </div>
  );
}
